import React, {Component} from 'react';
import {Link} from 'react-router';
import './SingleBook.css';
import {Helmet} from 'react-helmet'

export default class SingleBook extends Component {
    constructor(props) {
        super(props);
        //出版社名称和课本索引
        let {presspinyin, bookId} = this.props.params;
        //获取当前书本的信息
        this.courseData = window.AllBooksForPress.filter(m => m.presspinyin === presspinyin)[0]["books"][bookId];
        this.state = {
            lessonData: [],
            wordCounts: null,
            bookDetail: {}
        }
    };

    componentDidMount() {
        this.getLessonList();
    }

    getLessonList = () => {
        fetch(`https://www.gankao.com/api/newWord/lesson?book_id=${this.props.params.bookId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(data => {
            if (data && data.status === 200) {
                // console.log("获取课本列表成功:", data.data);
                this.setState({
                    lessonData: data.data.data,
                    wordCounts: data.data.wordCounts,
                    bookDetail: data.data.bookDetail
                });
            }
        })
        .catch(err => {
            console.log('获取课本列表失败:', err);
        });
    }

    /**
     * 根据订单id获取订单详细数据
     * @param  {[number]} id [订单ID]
     * @return {[order]}    [订单详细信息]
     */
    render() {
        let { lessonData, wordCounts,bookDetail } = this.state;
        // console.log(bookDetail, 222);
        let courseName = bookDetail.name
        let courseBanner = bookDetail.course_banner
        // let {book_data: {  lessonIcon,}} = this.courseData;
        let {presspinyin, bookId} = this.props.params

        //计算这本书总共多少个汉字wq
        // let wordCounts = lesson.reduce((pre, next) => {
        //     return pre + next["words"].length;
        // }, 0)
        // console.log("window.location.href....",window.location.href)
        return (<div className="App">
            <Helmet>
                <meta name="gankao_sharable" content="1"/>
                <meta name="wx_share_title" content={courseName}/>
                <meta name="wx_share_content" content={bookDetail.course_desc}/>
                <meta name="wx_share_link" content={window.location.href}/>
                <meta name="wx_share_imgurl" content={courseBanner}/>
                <title>
                    {courseName}
                </title>
            </Helmet>
            {this.props.children && this.props.children}
            {!this.props.children && <div style={{backgroundColor: "white",padding:"10px 15px"}}>
                {/*头部banner信息start*/}
                {/* <Link to={`/press/${presspinyin}`}>
                    <div className="goBookList">
                        <span style={{marginRight: "5px"}}>
                            <img src="https://img.qiaoxuesi.com/market/indexImg/1528078756956.PNG" alt=""/>
                        </span>
                        返回
                    </div>
                </Link>*/}
                <div className="courseTitleArea">
                    <div className="leftCourseImg">
                        <img style={{height: "150px", border: "1px solid #fbf5f5"}} src={courseBanner} alt=""/>
                    </div>
                    <div className="rightTextDesc">
                        <h1 style={{ fontSize: "16px", color: "#000000" }}>{courseName}</h1>
                        { 
                            wordCounts &&<div style={{color: "#B4B4B4", fontSize: "14px", marginTop: "5px",}}>{wordCounts}个字</div>
                        }
                        
                        <div
                            style={{
                                color: "#B4B4B4",
                                fontSize: "12px",
                                marginTop: "5px"
                            }}>
                            {bookDetail.course_desc}
                        </div>
                    </div>
                </div>
                <div style={{clear: "both"}}>

                </div>

               {/* <div style={{
                    height: "10px",
                    background: "#F8F8F8",
                    position: "fixed",
                    left: "0",
                    right: "0",
                    top: "180px"
                }}>
                </div>*/}
                {/*头部banner信息end*/}
                <div className="catalogList">

                    {/*目录列表start*/}
                    {lessonData.map((item, index) => {
                        // console.log(item,333)
                        return <Link
                        //     to={{
                        //     pathname:`press/${presspinyin}/book/${bookId}/word/${index}/subject/:${item.name}`,
                        // }}
                            to={`press/${presspinyin}/book/${bookId}/word/${item.id}`}
                            key={"course" + item.id}>
                            <div className="catalogItem">
                                <div className="imgIcon"
                                     style={{marginRight: "20px", width: "35px", lineHeight: "100%"}}>
                                    <img style={{width: "100%"}} src={bookDetail.lesson_icon} alt=""/>
                                </div>
                                <div className="textBox">
                                    <div style={{color: "#000000", fontSize: "14px"}}>{item.name}</div>
                                    <div style={{color: "#969696", fontSize: "12px"}}>
                                        {item.word_count}个字
                                    </div>
                                </div>
                            </div>
                        </Link>
                    })}
                </div>
                {/*目录列表end*/}


            </div>}


        </div>);
    }
}




// WEBPACK FOOTER //
// ./src/components/single_book/SingleBook.js